import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { AuthApi } from 'src/app/shared/apis/auth.api';
import { LangModel } from 'src/app/shared/interfaces/country.interface';
import { MemberSettingItem } from './type';

@UntilDestroy()
@Component({
  selector: 'app-member-setting',
  templateUrl: './member-setting.component.html',
  styleUrls: ['./member-setting.component.scss'],
})
export class MemberSettingComponent implements OnInit {
  constructor(private dialog: MatDialog, private appService: AppService, private authApi: AuthApi) {}

  settings: MemberSettingItem[] = [
    {
      title: 'lang',
      value: '',
    },
  ];
  allLangs: LangModel[] | undefined;

  ngOnInit(): void {
    this.appService.languages$.pipe(untilDestroyed(this)).subscribe(x => {
      this.allLangs = x;
      const code = this.appService.languageCode;
      const lang = this.allLangs?.find(x => x.code === code);
      this.settings[0].value = lang?.name || '简中';
    });
  }

  /**
   * 设置项目点击
   *
   * @param item
   */
  selectMenu(item: MemberSettingItem) {
    switch (item.title) {
      case 'lang':
        this.appService.openLazyComponentDialog('SelectLangDialogComponent');
        break;
      default:
    }
  }

  /**
   *  退出登录
   */
  logOut() {
    this.appService.logoutSubject$.next(true);
  }
}
